export const PridobivanjeProgramov = {
  methods: {
    GetTvProgrami (prenParametri) {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('grupiranjeStoritev=1')
      this.clientAgent.postWsRequest(
        this,
        '/prikljucek/storitve/naborTvStoritev?',
        param,
        prenParametri,
        'SetTvProgrami',
        'ErrTvProgrami')
    },
    SetTvProgrami (podatki, prenParametri) {
      let seznamProgramov = []
      let seznamShem = []
      let tvVmesnikCenik = []
      let seznamTvVmesnikov = []
      let seznamTvProgramov = podatki.naborTvProgramov
      let seznamProgramskihShem = podatki.naborShem
      let cenikTvVmesnikov = podatki.cenikTvVmesnikov
      let seznamVmesnikov = podatki.naborTvVmesnikov
      let hboGoLink = podatki.dodatno.hboGoLink
      for (let i = 0; i < seznamTvProgramov.length; i++) {
        seznamProgramov.push(seznamTvProgramov[i])
      }
      for (let i = 0; i < seznamProgramskihShem.length; i++) {
        seznamShem.push(seznamProgramskihShem[i])
      }
      for (let i = 0; i < cenikTvVmesnikov.length; i++) {
        tvVmesnikCenik.push(cenikTvVmesnikov[i])
      }
      for (let i = 0; i < seznamVmesnikov.length; i++) {
        seznamTvVmesnikov.push(seznamVmesnikov[i])
      }
      let vmesnik = prenParametri.vmesnik
      vmesnik.SetSeznamPodatkovTelevizija(prenParametri, seznamProgramov)
      vmesnik.SetSeznamPodatkovProgramskeSheme(prenParametri, seznamShem)
      vmesnik.SetCenikTvVmesnikov(prenParametri, tvVmesnikCenik)
      if (hboGoLink) {
        vmesnik.PrikaziHBOGoLink()
      }
      vmesnik.SetSeznamTvVmesnikov(prenParametri, seznamTvVmesnikov)
      vmesnik.KliciMetodeSSeznama(prenParametri)
    },
    ErrTvprogrami (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/NarociTelevizija/GetNarociTelevizija.js